import type { OnInit } from '@angular/core'
import { Component, inject } from '@angular/core'
import type { FormGroup } from '@angular/forms'
import { FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms'
import { RouterLink } from '@angular/router'

import { TranslatePipe } from '@ngx-translate/core'

import { OurSubscriptionsComponent } from '../../../../pages/home/components/our-subscriptions/our-subscriptions.component'
import { ContactHeaderComponent } from '../../components/contact/contact-header/contact-header.component'

@Component({
  selector: 'dhp-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.scss'],
  imports: [
    ContactHeaderComponent,
    RouterLink,
    ReactiveFormsModule,
    OurSubscriptionsComponent,
    TranslatePipe,
  ],
})
export class ContactComponent implements OnInit {
  private fb = inject(FormBuilder)

  contactForm!: FormGroup

  ngOnInit(): void {
    this.initForm()
  }

  private initForm(): void {
    this.contactForm = this.fb.group({
      naam: ['', Validators.required],
      voornaam: ['', Validators.required],
      email: ['', [Validators.required, Validators.email]],
      telefoonnummer: ['', Validators.required],
      onderwerp: [''],
      bericht: ['', Validators.required],
    })
  }

  onSubmit(): void {
    if (this.contactForm.valid) {
      // Handle form submission
    } else {
      // Mark all fields as touched to trigger validation messages
      Object.values(this.contactForm.controls).forEach(control => {
        control.markAsTouched()
      })
    }
  }
}
